// extracted by mini-css-extract-plugin
export default {"subtitle":"PageModulesStyles_subtitle__WnEzx","editableParagraph":"PageModulesStyles_editableParagraph__FfbW8"};